;(function () {
  const SECTION = 'filterCategoryBlocks'

  const EVENTS = {
    update: 'filterCategoryBlocks:update',
  }

  const sanitizedWindowParams = (url) => {
    const sanitizedWindowParams = new URLSearchParams()

    for (const [key, value] of Array.from(url.searchParams)) {
      if (
        key.includes('filter') &&
        !key.includes('availability') &&
        !key.includes('option')
      ) {
        sanitizedWindowParams.append(key, value)
      }
    }

    return sanitizedWindowParams
  }

  const sortParams = (p) => {
    p.sort()
    return p
  }

  const setPageUpdate = ({ requestURL }) => {
    window.history.pushState({}, '', requestURL)

    SAXX.App.emit(SAXX.Events.CollectionFilterEvent, null, {
      section: SECTION,
    })

    filterCategoryBlockEvent({ requestURL })
  }

  const filterCategoryBlockEvent = (
    { requestURL = new URL(window.location) } = {
      requestURL: new URL(window.location),
    },
  ) => {
    SAXX.App.emit(EVENTS.update, null, { url: requestURL })

    if (window.nostojs) {
      window.nostojs(function (api) {
        api.loadRecommendations()
      })
    }
  }

  const components = {
    collectionFilterTiles: SAXX.Init.Component((node, ctx) => {
      const filterTileLinks = node.querySelectorAll('a[href^="?"]')
      const filterTiles = node.querySelectorAll(
        ':scope > [class*="tile"][data-href^="?"]',
      )

      ctx.on(SAXX.Events.CollectionFilterEvent, (_, details) => {
        if (details.section !== SECTION) filterCategoryBlockEvent()
      })

      window.addEventListener('popstate', () => {
        filterCategoryBlockEvent()
      })

      const tileStatusUpdate = (tile, url = new URL(window.location)) => {
        const windowParams = sanitizedWindowParams(url)
        const tileParams = sanitizedWindowParams(
          new URL(window.location.origin + tile.getAttribute('data-href')),
        )

        if (
          tile.getAttribute('data-href') === '' ||
          tile.getAttribute('data-href') === '?'
        ) {
          tile.classList.toggle('active', Array.from(windowParams).length === 0)
          return
        }

        tile.classList.toggle(
          'active',
          sortParams(windowParams).toString() ===
            sortParams(tileParams).toString(),
        )
      }

      filterTiles.forEach((tile) => {
        ctx.on(EVENTS.update, (_, details) => {
          tileStatusUpdate(tile, details.url)
        })

        tileStatusUpdate(tile)
      })

      filterTileLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          if (link.getAttribute('target') === '_blank') return
          e.preventDefault()

          const requestURL = new URL(window.location)

          if (
            link.getAttribute('href') === '' ||
            link.getAttribute('href') === '?'
          ) {
            requestURL.search = ''
            setPageUpdate({ requestURL })
            return
          }

          requestURL.search = new URL(link.href).search

          setPageUpdate({ requestURL })
        })
      })
    }),
  }
  Object.assign(SAXX.Init.Components, components)
})()
